import { ReasonEditKind } from '../../LoanCicHistory.constants';

export const ORIGINAL_REASON_PREFIX = 'Original: ';

export const CHANGED_BY_PREFIX = 'changed by';

const REASON_CHANGED_BY_PREFIX = 'Reason changed by';

const COMMENT_CHANGED_BY_PREFIX = 'Comment changed by';

export const EditedByPrefix = {
  [ReasonEditKind.REASON_CHANGED]: REASON_CHANGED_BY_PREFIX,
  [ReasonEditKind.COMMENT_CHANGED]: COMMENT_CHANGED_BY_PREFIX,
};
